export default "<app-login-card></app-login-card>\r\n";